import { addDays, format } from "date-fns";
import http from "./https";

export const storeRemissions = async (payload) => {
  const response = await http.post(`/remissions`, payload);
  return response.data;
};
